const ToastMessages = {
  errorCode: "These credentials do not match with our records.",

  // demo students module message
  demoStudentsAdd: "Student has been created successfully.",
  demoStudentsUpdated: "Student data has been updated successfully.",
  demoStudentsDelete: "Student data has been successfully deleted.",

  // pte students module message
  pteStudentsAdd: "Student has been created successfully.",
  pteStudentsUpdated: "PTE Student data has been updated successfully.",
  pteStudentsDelete: "PTE Student data has been successfully deleted.",

  // batch module message
  batchUpdated: "Batch has been updated successfully.",
  batchDeleted: "Batch has been deleted successfully",
  batchAdd: "Batch has been created successfully",

  // teacher module message
  teachersAdd: "Teachers has been created successfully.",
  teachersUpdated: "Teachers has been updated successfully.",
  teachersDeleted: "Teachers has been deleted successfully",

  // expense module message
  expenseAdd: "Expense has been added successfully.",
  expenseUpdated: "Expense information has been updated successfully.",
  expenseDeleted: "Expense information has been deleted successfully",

  // student performnace module message
  performanceAdd: "Marks deatil has been added successfully.",
  performanceUpdated: "Marks deatil has been updated successfully.",
  performanceDeleted: "Marks deatil has been deleted successfully",

  // user module message
  userAdd: "User has been added successfully.",
  userUpdated: "User information has been updated successfully.",
  userDeleted: "User information has been deleted successfully",

  // attendance module message
  attendance: "Attendance has been saved successfully.",
  attendanceUpdate: "Attendance has been updated successfully.",
  batch: "Select the batch",
  teacherAttendance: "Please mark attendance",

  // Visa module message
  visaAdd: "Visa Info has been added successfully",
  visaUpdated: "Visa regarding information has been updated successfully.",
  visaDeleted: "Visa regarding information has been deleted successfully",

    // Notes module message
  noteAdd: "Note has been added successfully",
  noteUpdated: "Note has been updated successfully.",
  noteDeleted: "Note has been deleted successfully",

  filterDate: "Please select the start and end date",

  // Fee module message
  feeDetailAdd: "Fee detail has been added successfully",
};

export default ToastMessages;
